import { UploadOutlined } from "@ant-design/icons";
import {
  Button,
  Form,
  message,
  Modal,
  Row,
  Space,
  Spin,
  Table,
  Typography,
  Upload,
} from "antd";
import { useEffect, useRef, useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import ModalCustom from "../../components/ModalCustom/ModalCustom";
import contractUpload from "../../api/contractUpload";
import Notification from "../../components/Notification";
import ListActionButton from "../../components/ListActionButton/ActionListButton";
import {
  dataFindContract,
  dataFormUpload,
  dataSendEmail,
  listColumnsTableCreated,
} from "./config";
import Search from "../../components/Search/Search";
import { formatDateToString } from "../../helper/common";
import user from "../../api/user";
import InputFields from "../../components/InputFields/InputFields";

const ContractUploaded = () => {
  const [fileUrl, setFileUrl] = useState("");

  const [dataTableCreated, setDataTableCreated] = useState([]);

  const [total, setTotal] = useState();
  const previewContract = useRef();
  const [loadingPage, setLoadingPage] = useState(false);
  const [params, setParams] = useState({
    pageNumber: 1,
    pageSize: 20,
  });

  const sendEmailRef = useRef();
  const [formSendEmail] = Form.useForm();

  const [dataSource, setDataSource] = useState(dataFormUpload);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isDownload, setIsDownload] = useState(false);
  const [isDel, setIsDel] = useState([]);
  const [fileList, setFileList] = useState([]);
  const findRef = useRef();
  const [optionsLeaders, setOptionsLeaders] = useState([]);
  const [dataSearch, setDataSearch] = useState(dataFindContract);
  const [filesUploading, setFilesUploading] = useState([]);
  const [idSentEmail, setIdSentEmail] = useState(null);

  const uploadContractRef = useRef();
  const [formUploadContract] = Form.useForm();

  const getListLeader = async () => {
    try {
      const res = await user.getListLeader();
      const options = res.data.map((opt) => ({
        label: opt.fullName,
        value: opt.id,
      }));
      setOptionsLeaders(options);
    } catch (error) {
      Notification("error", "Lấy danh sách leader không thành công");
    }
  };

  const getListContractUpload = async () => {
    try {
      const res = await contractUpload.listContractUpload({
        ...params,
        fromDate: formatDateToString(params.fromDate),
      });
      const newData = res.data.data.map((item, index) => ({
        ...item,
        key: index,
      }));
      setDataTableCreated(newData);
      setTotal(res.data.total);
      Notification("success", "Lấy danh sách hợp đồng thành thành công");
    } catch (error) {
      Notification("error", "Lấy danh sách hợp đồng không thành công");
    }
  };

  const onChangePagination = (pageNumber, pageSize) => {
    setParams({ ...params, pageNumber: pageNumber, pageSize: pageSize });
  };

  const deleteContracted = async (id) => {
    setLoadingPage(true);
    try {
      if (isDel?.length > 0) {
        await contractUpload.deleteContractUpload({ ids: isDel });
      } else await contractUpload.deleteContractUpload({ ids: id });
      Notification("success", "Xóa hợp đồng thành công");
      getListContractUpload();
      setSelectedRowKeys(null);
      setLoadingPage(false);
    } catch (error) {
      console.log("🚀 ~ deleteContracted ~ error:", error);
      setLoadingPage(false);

      Notification("error", "Xóa hợp đồng thất bại");
    }
  };

  const showContract = async (id) => {
    setLoadingPage(true);
    try {
      const res = await contractUpload.detailsContractUpload(id);
      const { base64, fileType } = res.data;
      const fileUrl = `data:${fileType};base64,${base64}`;
      setFileUrl(fileUrl);
      previewContract.current.openModal();
      setLoadingPage(false);
    } catch (error) {
      setLoadingPage(false);
      Notification("error", "Đã xảy ra lỗi khi xem chi tiết");
    }
  };

  const sendEmail = async (id) => {
    if (!idSentEmail) {
      Notification("error", "Chưa có hợp đồng để gửi email");
      return;
    }

    try {
      const values = await formSendEmail.validateFields();
      console.log("🚀 ~ sendEmail ~ values:", values);

      const payload = {
        documentId: idSentEmail,
        toEmails: values.toEmails
          ? values.toEmails
              .split(",")
              .map((e) => e.trim())
              .filter(Boolean)
          : null,
        ccEmails: values.ccEmails
          ? values.ccEmails
              .split(",")
              .map((e) => e.trim())
              .filter(Boolean)
          : null,
        bccEmails: values.bccEmails
          ? values.bccEmails
              .split(",")
              .map((e) => e.trim())
              .filter(Boolean)
          : null,
      };
      await contractUpload.sendEmailContractUpload(payload);
      sendEmailRef.current.closeModal();
      formSendEmail.resetFields();
      Notification("success", "Gửi email thành công");
    } catch (error) {
      console.log("Lỗi", error);
      Notification("error", "Gửi email thất bại");
    }
  };

  const openModalSendEmail = async (id) => {
    sendEmailRef.current.openModal();
    setIdSentEmail(id);
  };

  const handleSearch = () => {
    const data = findRef.current?.getData();
    setParams({
      ...params,
      ...data,
      pageNumber: 1,
    });
  };
  const onSelectChange = (selectedRowKeys, row) => {
    setSelectedRowKeys(selectedRowKeys);
    const isDel = [];
    row.map((item) => isDel.push(item.id));
    if (isDel.length > 0) {
      setIsDel(isDel);
    }
    setIsDownload(selectedRowKeys.length > 0 ?? false);
  };
  // rowSelection object indicates the need for row selection
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleChange = async () => {
    try {
      setLoadingPage(true);
      const values = await formUploadContract.validateFields();
      const realFiles = filesUploading
        .map((f) => f.originFileObj || f)
        .filter(Boolean);
      if (realFiles.length === 0) {
        message.error("Vui lòng chọn file để tải lên!");
        setLoadingPage(false);
        return;
      }
      if (realFiles.length > 20) {
        message.error("Bạn chỉ được tải tối đa 20 file!");
        setLoadingPage(false);
        return;
      }

      // Tạo FormData
      const formData = new FormData();
      realFiles?.forEach((f) => formData.append("files", f));
      formData.append("leadTeam", values.leadTeam);
      await contractUpload.documentUpload(formData);
      Notification("success", `Đã upload ${filesUploading.length} file.`);
      setFileList([]);
      getListContractUpload();
      setLoadingPage(false);
      uploadContractRef.current.closeModal();
      formUploadContract.resetFields();
      setFilesUploading([]);
    } catch (err) {
      setLoadingPage(false);
      console.error(err);
      Notification("error", "Upload thất bại!");
    }
  };

  const customRequest = (options) => {
    console.log("🚀 ~ customRequest ~ options:", options);
    setLoadingPage(true);
    const { file } = options;
    const isPDF = file.type === "application/pdf";
    // Kiểm tra loại file (chỉ cho phép PDF)
    if (!isPDF) {
      Notification("error", "Chỉ được tải lên file PDF!");
      setLoadingPage(false);
      return;
    }
    setFilesUploading(options?.fileList);
    setLoadingPage(false);
  };
  //columns bảng
  const columns = listColumnsTableCreated.map((e) => {
    if (e.key === "stt") {
      return {
        ...e,
        render: (text, record, index) =>
          (params.pageNumber - 1) * params.pageSize + index + 1,
      };
    } else if (e.key == "action") {
      return {
        ...e,
        render: (_, record, index) => (
          <ListActionButton
            deleteFunction={() => deleteContracted(record.id)}
            showDetailFunction={() => showContract(record.id)}
            sendEmail={() => openModalSendEmail(record.id)}
            record={record}
          />
        ),
      };
    }
    return e;
  });

  useEffect(() => {
    // const newFieldsSearch = dataSearch.map((item) =>
    //   item.name === "leadTeam"
    //     ? {
    //         ...item,
    //         options: optionsLeaders,
    //       }
    //     : { ...item }
    // );
    // setDataSearch(newFieldsSearch);
    const newDataSource = dataSource.map((field) =>
      field.name === "leadTeam" ? { ...field, options: optionsLeaders } : field
    );
    setDataSource(newDataSource);
  }, [optionsLeaders]);

  // Gọi danh sách
  useEffect(() => {
    getListContractUpload();
  }, [params]);

  useEffect(() => {
    getListLeader();
  }, []);

  return (
    <Spin spinning={loadingPage}>
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        {/* Danh sách hợp đông */}
        <div
          onKeyDown={(e) => {
            if (e.keyCode === 13) {
              handleSearch();
            }
          }}
          className="container"
        >
          <Row>
            <Search
              fields={dataSearch}
              onClickSearch={handleSearch}
              ref={findRef}
            />
          </Row>
        </div>
        {/* Hết */}
        {/* ------------------- */}
        <div className="container">
          <Space direction="vertical" size="middle" style={{ width: "100%" }}>
            <Row justify="space-between">
              <div className="title">Danh sách hợp đồng đã tải lên</div>
              {selectedRowKeys?.length > 0 && (
                <div>
                  Đã chọn <strong>{selectedRowKeys?.length}</strong> hợp đồng{" "}
                </div>
              )}

              <Button
                type="primary"
                className="btn-sub"
                icon={<UploadOutlined rev={undefined} />}
                onClick={() => {
                  uploadContractRef.current.openModal();
                }}
              >
                Tải lên hợp đồng
              </Button>
            </Row>
            {/* Danh sách hợp đồng đã tạo */}
            <Table
              columns={columns}
              dataSource={dataTableCreated}
              pagination={{
                position: ["bottomRight"],
                showSizeChanger: true,
                total: total,
                pageSize: params.pageSize,
                current: params.pageNumber,
                onChange: onChangePagination,
              }}
              rowSelection={rowSelection}
              bordered
            />
          </Space>
        </div>
        {/* Hết */}
        {/* ------------------- */}

        <ModalCustom
          ref={uploadContractRef}
          title="Tải lên hợp đồng"
          width={1600}
        >
          <Spin spinning={loadingPage}>
            <Space
              direction="vertical"
              size={"middle"}
              style={{ width: "100%" }}
            >
              <Form form={formUploadContract} labelAlign="left">
                <Row gutter={[16, 16]}>
                  <InputFields data={dataSource} />
                </Row>
              </Form>
              {
                /* Upload file */
                filesUploading?.length > 0 ? (
                  <Row justify={"space-between"}>
                    <Typography.Text strong style={{ fontSize: "16px" }}>
                      Đã tải lên {filesUploading?.length} hợp đồng
                    </Typography.Text>
                    <Upload
                      multiple
                      showUploadList={false}
                      beforeUpload={() => false}
                      maxCount={20}
                      onChange={customRequest}
                      fileList={fileList}
                    >
                      <Button
                        type="primary"
                        className="btn-sub"
                        icon={<UploadOutlined rev={undefined} />}
                      >
                        Tải lại hợp đồng
                      </Button>
                    </Upload>
                  </Row>
                ) : (
                  <Upload
                    multiple
                    showUploadList={false}
                    beforeUpload={() => false}
                    maxCount={20}
                    onChange={customRequest}
                    fileList={fileList}
                  >
                    <Button
                      type="primary"
                      className="btn-sub"
                      icon={<UploadOutlined rev={undefined} />}
                    >
                      Tải lên hợp đồng
                    </Button>
                  </Upload>
                )
              }
              <Row justify={"end"}>
                <Space đirection="horizontal" size="small">
                  <Button onClick={handleChange} type="primary">
                    Tải lên
                  </Button>
                  <Button
                    danger
                    onClick={() => uploadContractRef.current.closeModal()}
                  >
                    Hủy
                  </Button>
                </Space>
              </Row>
            </Space>
          </Spin>
        </ModalCustom>

        {/* Xem hợp đồng */}
        <ModalCustom
          ref={previewContract}
          title="Xem trước hợp đồng"
          width={1600}
        >
          <Spin spinning={fileUrl ? false : true}>
            <Space
              direction="vertical"
              size={"middle"}
              style={{ width: "100%" }}
            >
              <div>
                {fileUrl && (
                  <iframe
                    src={fileUrl}
                    width="100%"
                    height="700px"
                    style={{ border: "none" }}
                  />
                )}
              </div>
            </Space>
          </Spin>
        </ModalCustom>
        {/* Hết */}
        {/* ------------------- */}

        {/* ------------------- */}
        {/* Gửi mail */}
        <ModalCustom
          ref={sendEmailRef}
          title="Gửi hợp đồng cho khách hàng"
          width={1600}
        >
          <Spin spinning={loadingPage}>
            <Space
              direction="vertical"
              size={"middle"}
              style={{ width: "100%" }}
            >
              <Form form={formSendEmail} labelAlign="left">
                <Row gutter={[16, 16]}>
                  <InputFields data={dataSendEmail} />
                </Row>
              </Form>
              <Row justify={"end"}>
                <Space đirection="horizontal" size="small">
                  <Button onClick={sendEmail} type="primary">
                    Gửi mail
                  </Button>
                  <Button
                    danger
                    onClick={() => uploadContractRef.current.closeModal()}
                  >
                    Hủy
                  </Button>
                </Space>
              </Row>
            </Space>
          </Spin>
        </ModalCustom>
      </Space>
    </Spin>
  );
};

export default ContractUploaded;
